import React, { useEffect, useState } from "react";
import "./Expert_Tab_History.css";
import Common_Login_Expert_Details from "../../../common_components/common-login-expert-details/Common_Expert_Login_Details";
import { getExpertCustomerHistory } from "../../../../features/admin/vendor_expert/Slice";
import { useDispatch, useSelector } from "react-redux";

const Data = [
  {
    id: 1,
    name: "Shubham Mane",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Abhishek More",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 3,
    name: "Pratik Mohol",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 1,
    name: "Shubham Mane",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Abhishek More",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Pratik mohol",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 1,
    name: "Shubham Mane",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Abhishek More",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Pratik Mohol",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
];

const Expert_Tab_History = () => {
  const dispatch = useDispatch();
  const expertcustomerhistory =
    useSelector(
      (state) => state?.vendor_expert?.vendorexperts?.expertcustomerhistory,
    ) || [];
  console.log(
    expertcustomerhistory,
    "expertcustomerhistoryexpertcustomerhistory",
  );

  useEffect(() => {
    dispatch(getExpertCustomerHistory());
  }, [dispatch]);

  const [showLoginHistory, setShowLoginHistory] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const handleCallClick = (vendorData) => {
    setSelectedVendor(vendorData);
    setShowLoginHistory(true);
  };
  const handleCloseModal = () => {
    setShowLoginHistory(false);
    setSelectedVendor(null);
  };
  return (
    <div className="expert-history-tab-section">
      <div className="container mt-4 vendor-login-section">
        {/* <div className="row">
          {expertcustomerhistory?.data?.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
              <Common_Login_Expert_Details
                data={item}
                onCallClick={() => handleCallClick(item)}
              />
            </div>
          ))}
        </div> */}
        <div className="row">
          {expertcustomerhistory?.data &&
          expertcustomerhistory.data.length > 0 ? (
            expertcustomerhistory.data.map((item, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
              >
                <Common_Login_Expert_Details
                  data={item}
                  onCallClick={() => handleCallClick(item)}
                />
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <h5>No Data Available</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Expert_Tab_History;
